import { createApi } from "@reduxjs/toolkit/query/react";

import { tomService } from "./restService";

export const benefitsPlanApi = createApi({
  reducerPath: "benefitsPlanApi",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  }),
  tagTypes: ["BenefitsPlan", "BenefitsPlanVersions"],
  endpoints: builder => ({
    fetchBenefitsPlans: builder.query({
      query: ({ company_id, page = 1 }) => ({
        url: `/company/${company_id}/benefit-plans/?page=${page}`,
        method: "GET",
      }),
      providesTags: ["BenefitsPlan"],
    }),
    fetchBenefitPlanTypes: builder.query({
      query: () => ({
        url: `/benefit-plan-types/`,
        method: "GET",
      }),
    }),
    fetchBenefitsPlanVersions: builder.query({
      query: ({ company_id, page = 1 }) => ({
        url: `/company/${company_id}/cash-allowance-versions/?page=${page}`,
        method: "GET",
      }),
      providesTags: ["BenefitsPlanVersions"],
    }),

    createBenefitsPlan: builder.mutation({
      query: ({ body, company_id }) => ({
        url: `/company/${company_id}/benefit-plans/create/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["BenefitsPlan"],
    }),
    deleteBenefitsPlan: builder.mutation({
      query: ({ id, company_id }) => ({
        url: `/company/${company_id}/benefit-plans/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["BenefitsPlan"],
    }),
    updateBenefitsPlan: builder.mutation({
      query: ({ id, company_id, body }) => ({
        url: `/company/${company_id}/benefit-plans/${id}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["BenefitsPlan"],
    }),
    updateBenefitsPlanVersion: builder.mutation({
      query: ({ id, company_id }) => ({
        url: `/company/${company_id}/benefit-plans/${id}/`,
        method: "PATCH",
      }),
      invalidatesTags: ["BenefitsPlan", "BenefitsPlanVersions"],
    }),
    uploadBenefitsPlan: builder.mutation({
      query: ({ company_id, active, body }) => ({
        url: `/company/${company_id}/cash-allowance/upload/?active=${active}`,
        method: "POST",
        body,
        formData: true,
      }),
      invalidatesTags: ["BenefitsPlan", "BenefitsPlanVersions"],
    }),
    downloadBenefitsPlans: builder.query({
      query: ({ company_id, version_id }) => ({
        url: `/company/${company_id}/cash-allowance/download/${
          version_id ? `?version_id=${version_id}` : ""
        }`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useFetchBenefitsPlansQuery,
  useFetchBenefitPlanTypesQuery,
  useCreateBenefitsPlanMutation,
  useDeleteBenefitsPlanMutation,
  useUpdateBenefitsPlanMutation,
  useFetchBenefitsPlanVersionsQuery,
  useUpdateBenefitsPlanVersionMutation,
  useUploadBenefitsPlanMutation,
  useDownloadBenefitsPlansQuery,
} = benefitsPlanApi;
